<template>
  <div class="container my-6">
    <div class="row">
      <div class="col-12">
        <div class="page">
          <div class="error-wrapper">
            <div class="error-wrapper__content">
              <div class="error-wrapper__w404">
                <svg class="raw" xmlns="http://www.w3.org/2000/svg" width="337" height="147" viewBox="0 0 337 147"
                     fill="none">
                  <path
                    d="M171.464 2.7303C180.568 2.7303 193.272 6.08964 204.705 19.7395C215.715 32.7595 222.701 51.6598 222.701 74.7598C222.701 97.8597 215.715 116.76 204.705 129.78C194.542 141.75 182.262 147 171.464 147C160.666 147 148.386 141.75 138.224 129.78C127.214 116.76 120.227 97.8597 120.227 74.7598C120.227 51.6598 127.214 32.7595 138.224 19.7395C149.657 6.08993 162.36 2.73033 171.464 2.7303ZM85.3242 109.62H105.014V118.02H85.3242V144.69H76.0085V118.02H0L85.3242 0V109.62ZM317.31 109.62H337V118.02H317.31V144.69H307.994V118.02H231.986L317.31 0V109.62ZM171.464 11.1295C158.972 11.1296 150.292 18.9002 145.21 25.2001C136.106 36.3301 129.967 52.29 129.967 74.7598C129.967 97.0195 136.106 113.189 145.21 124.319C155.585 137.129 166.594 138.6 171.464 138.6C176.334 138.6 187.343 137.129 197.718 124.319C206.822 113.189 212.962 97.0196 212.962 74.7598C212.962 52.2899 206.822 36.3301 197.718 25.2001C192.636 18.9001 183.956 11.1295 171.464 11.1295ZM16.5138 109.62H76.0085V27.2997L16.5138 109.62ZM248.5 109.62H307.994V27.2997L248.5 109.62Z"
                    fill="url(#paint0_linear_83_551)" />
                  <defs>
                    <linearGradient id="paint0_linear_83_551" x1="171.795" y1="178.023" x2="171.795" y2="-31.9766"
                                    gradientUnits="userSpaceOnUse">
                      <stop offset="0.0828012" stop-color="#060606" />
                      <stop offset="0.876918" stop-color="#303030" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h1 class="h2 error-wrapper__title">{{ 'Page not found' }}</h1>
              <p class="error-wrapper__subtitle">
                {{ 'Please refresh the page or try again later.' }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageNotFound'
}
</script>
